import { adjustBrightness, makeTranslucent } from '../utils/colors';

// Semantic design tokens (lifted from DecisionSupport.styled — used across V3
// reassign dialog + decision-support primitives). Treat as the start of a
// shared palette rather than scoped tokens.
export const NEUTRAL_BLUE = '#344054';
export const SURFACE_GRAY = '#F6F8FA';
export const SYSTEM_BLUE = '#5686BD';
export const BORDER_GRAY = '#D0D5DD';
export const LIGHT_TEAL = '#E5FFFC';
export const PRIMARY_TEAL = '#45BFB2';
export const WHITE = '#FFFFFF';
export const BORDER_RADIUS_SM_PX = 4;

// Background grays.
export const AXLE_PAGE_BACKGROUND_GRAY = '#FaFaFa';
export const MEDIUM_GRAY_BACKGROUND_FOR_CONTAINERS = '#F4F4F4';
export const LIGHT_GRAY_BACKGROUND_FOR_CONTAINERS = '#F0F0F0';
export const DEFAULT_HEADER_FOOTER_BACKGROUND_FOR_TABLES = '#f1f5f9';

// Text grays.
export const TEXT_GRAY = '#828283';

// Icon grays.
export const ICON_GRAY = '#828282';
export const ICON_LIGHT_GRAY = makeTranslucent(TEXT_GRAY, 0.4);

// Reds.
export const AXLE_RED = '#EB5757';

// Teals.
export const LIGHT_AXLE_TEAL_BACKGROUND = '#E7F5F5';
export const AXLE_TEAL = '#66C1BF';
export const DARK_AXLE_TEAL = adjustBrightness(AXLE_TEAL, -100);
export const DEEP_TEAL = '#007A75';

// Priorities
export const AXLE_PRIORITY_STANDARD = '#E7F5F4';
export const AXLE_PRIORITY_HIGH = '#B6E0DF';
export const AXLE_PRIORITY_URGENT = '#83CBC9';

// Visit issue highlighting reds and oranges.
export const VISIT_UNASSIGNED_ICON_COLOR = 'rgb(238, 67, 54)';
export const VISIT_UNASSIGNED_BACKGROUND_COLOR = 'rgba(238, 67, 54, 0.05)';
export const VISIT_LATE_ICON_COLOR = 'rgb(233,169,58)';
export const VISIT_LATE_BACKGROUND_COLOR = '#fafce5d9';

// This color is the same as the "High Priority" color in the <PriorityChip/>,
//  hardcoded in the back-end.  We don't have centralized alerting/alert colors in the
//  front-end, so we're just using this color for now.
export const HIGH_PRIORITY_COLOR = '#F27E7E';

// Darkest to lightest colors
export const WEEKDAY_FADING_COLOR_PALETTE = ['#94DBD8', '#C0E5E2', '#D6E6E5'];
export const FADING_COLOR_PALETTE_EXTENDED = [AXLE_TEAL, '#94DBD8', '#C0E5E2', '#D6E6E5'];

// Categorical palette for distinguishing groups on the map (one color per
// clinician). Google Charts' 20-color set: perceptually distinct and all
// medium-dark, so swatches read on a white legend and pins keep white text legible.
export const MAP_GROUP_COLOR_PALETTE = [
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
    '#e67300',
    '#8b0707',
    '#651067',
    '#329262',
    '#5574a6',
    '#3b3eac',
];

// Links
export const BLUE_LINK = '#0062FF';
export const BLUE_LINK_HOVER = adjustBrightness(BLUE_LINK, -40);

// Episode
export const EPISODE_COBALT_BLUE = '#3B82F6';
export const RECERT_WINDOW_COLOR = '#F59E0B';
export const HUV_WINDOW_COLOR = '#1F6F6A';
export const LUPA_RISK_COLOR = '#E5484D';

// Statuses
export const YELLOW_STATUS = '#EBEB34';

// Snooze pill
export const YELLOW_PILL_BG = '#FEF3C7';
export const YELLOW_PILL_TEXT = '#92400E';

export const TABLE_BORDER_COLOR = '#e2e8f0';
